// extracted by mini-css-extract-plugin
export var defaultWrapper = "_la-3";
export var downloadButton = "_la-4";
export var fileContainer = "_la-9 _la-7";
export var fileContainerBase = "_la-7";
export var fileContainerFixedHeight = "_la-8 _la-7";
export var fileInfo = "_la-5";
export var fileInfoWidthRestricted = "_la-6";
export var fileType = "_la-1";
export var fileTypeName = "_la-2";
export var image = "_la-0";
export var link = "_la-b";
export var overflowEllipsis = "_la-a";